import React from "react";
import { BrowserRouter } from "react-router-dom";
import { PublicRouters } from "../../routers";
import AppContext from "./context";

import { getConfig } from "../../utils/config";

const config = getConfig();

const font = config.theme.font;

import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  /* Importa as famílias do Google Fonts */
  @import url('${font.url}');
* {
  font-family: '${font.family}';
}
h1,
h2,
h3,
h4 {
  font-size: 1.3em;
}
`;

export default function Public() {
  const [loading, setLoading] = React.useState(false);

  return (
    <BrowserRouter>
      <GlobalStyle />
      <AppContext.Provider value={{ setLoading }}>
        <PublicRouters />
      </AppContext.Provider>
    </BrowserRouter>
  );
}



// WEBPACK FOOTER //
// ./src/views/Public/index.jsx